import { Action, PermissionCheckArgs, Process, System } from '@absg/angular-platform';

export abstract class PurchaseOrderPermission {
  static modification: PermissionCheckArgs = {
    action: Action.Edit,
    process: Process.PurchaseOrderManagement,
    system: System.NucleusInventory,
  };
  static schedule: PermissionCheckArgs = {
    action: Action.POSchedule,
    process: Process.StationSetup,
    system: System.NucleusInventory,
  };
  static finalApprover: PermissionCheckArgs = {
    action: Action.FinalApproval,
    process: Process.PurchaseOrderManagement,
    system: System.NucleusInventory,
  };
  static approve: PermissionCheckArgs = {
    action: Action.Approve,
    process: Process.PurchaseOrderManagement,
    system: System.NucleusInventory,
  };
  static assignPosition: PermissionCheckArgs = {
    action: Action.PositionManagement,
    process: Process.InventoryManagement,
    system: System.NucleusInventory,
  };
  static edit: PermissionCheckArgs = {
    action: Action.Edit,
    process: Process.PurchaseOrderManagement,
    system: System.NucleusInventory,
  };
  static poPermissions = [
    PurchaseOrderPermission.modification,
    PurchaseOrderPermission.approve,
    PurchaseOrderPermission.finalApprover];
}
